import {
  ACHBusinessType,
  ACHFundingAccountStatus,
  ACHLocationBusiness,
  ACHLocationDocumentStatus,
  ACHLocationStatus,
  ACHLocationDocument,
  AchLocationType,
} from '../giftcard-ach-service.types';

export const poolLocation: AchLocationType = {
  locationId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c-POOL_ACCOUNT',
  locationName: 'Pool Account Location',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  merchantId: '-',
  externalId: '392afe22-15dc-4f4f-83eb-94353bc0e8ce',
  firstName: 'retry',
  lastName: 'test',
  email: 'udith.s@aeturnum.com',
  phone: null,
  address1: '941 Massachusetts Ave',
  address2: 'null',
  city: 'Boston',
  state: 'Massachusetts',
  postalCode: '02118',
  ipAddress: null,
  businessName: 'retry',
  businessType: ACHBusinessType.LLC,
  businessClassification: null,
  fundingAccount: {
    id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
    externalId: '74276210-0e36-4e5a-a619-211c8ef35aab',
    externalURL:
      'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
    bankAccountType: 'SAVINGS',
    accountNickName: null,
    status: ACHFundingAccountStatus.VERIFIED,
    deleted: false,
    createdDate: '2024-02-06T10:08:20.439Z',
    modifiedDate: '2024-02-06T10:11:58.191Z',
    fingerprint:
      '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
  },
  type: ACHLocationBusiness.BUSINESS,
  status: ACHLocationStatus.VERIFIED,
  acceptedTOSAndPP: true,
  achLocationDocuments: [
    {
      status: ACHLocationDocumentStatus.VERIFIED,
      type: ACHLocationDocument.PASSPORT,
      failureReason: null,
    },
    {
      status: ACHLocationDocumentStatus.REVIEWED,
      type: ACHLocationDocument.LICENSE,
      failureReason: 'Not clear',
    },
  ],
  createdDate: '2023-09-11T15:15:34.727Z',
  modifiedDate: '2024-11-08T09:38:45.835Z',
  controller: {
    firstName: 'Controller',
    lastName: 'Name',
    title: 'CEO',
    dateOfBirth: null,
    address: {
      address1: '160 Apex Dr',
      address2: 'address 2',
      address3: 'address 3',
      city: 'Marlborough',
      stateProvinceRegion: 'MA',
      country: 'United States of America',
      postalCode: '01752',
    },
  },
  copiedFromLocationId: null,
  sharedCustomer: false,
  sharedFundingSource: false,
  fundTransferEnabled: true,
  overallStatus: 'VERIFIED',
};

export const achLocations: AchLocationType[] = [
  poolLocation,
  {
    locationId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
    locationName:
      'ACH Loc0 status Verified and funding account status Verified',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: {
      id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
      externalId: '74276210-0e36-4e5a-a619-211c8ef35aab',
      externalURL:
        'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
      bankAccountType: 'SAVINGS',
      accountNickName: null,
      status: ACHLocationStatus.VERIFIED,
      deleted: false,
      createdDate: '2024-02-06T10:08:20.439Z',
      modifiedDate: '2024-02-06T10:11:58.191Z',
      fingerprint:
        '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
    },
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.VERIFIED,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'VERIFIED',
  },
  {
    locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
    locationName:
      'ACH Loc1 status Verified and funding account status Unverified overall retry',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: {
      id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
      externalId: '74276210-0e36-4e5a-a619-211c8ef35aab',
      externalURL:
        'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
      bankAccountType: 'SAVINGS',
      accountNickName: null,
      status: ACHFundingAccountStatus.UNVERIFIED,
      deleted: false,
      createdDate: '2024-02-06T10:08:20.439Z',
      modifiedDate: '2024-02-06T10:11:58.191Z',
      fingerprint:
        '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
    },
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.VERIFIED,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'RETRY',
  },
  {
    locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6d5',
    locationName: 'ACH Loc2 without location external id',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: null,
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: {
      id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
      externalId: '74276210-0e36-4e5a-a619-211c8ef35aab',
      externalURL:
        'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
      bankAccountType: 'SAVINGS',
      accountNickName: null,
      status: ACHFundingAccountStatus.UNVERIFIED,
      deleted: false,
      createdDate: '2024-02-06T10:08:20.439Z',
      modifiedDate: '2024-02-06T10:11:58.191Z',
      fingerprint:
        '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
    },
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.VERIFIED,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'RETRY',
  },
  {
    locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6e5',
    locationName:
      'ACH Loc3 without funding external id - funding account status Unverified',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: {
      id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
      externalId: null,
      externalURL:
        'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
      bankAccountType: 'SAVINGS',
      accountNickName: null,
      status: ACHFundingAccountStatus.UNVERIFIED,
      deleted: false,
      createdDate: '2024-02-06T10:08:20.439Z',
      modifiedDate: '2024-02-06T10:11:58.191Z',
      fingerprint:
        '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
    },
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.RETRY,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'RETRY',
  },
  {
    locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c6',
    locationName: 'ACH Loc4 status Retry and funding account status Unverified',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: {
      id: 'be9e00a2-62b6-4a1c-b9b3-5d9ef07d286a',
      externalId: '74276210-0e36-4e5a-a619-211c8ef35aab',
      externalURL:
        'https://api.dwolla.com/funding-sources/74276210-0e36-4e5a-a619-211c8ef35aab',
      bankAccountType: 'SAVINGS',
      accountNickName: null,
      status: ACHFundingAccountStatus.UNVERIFIED,
      deleted: false,
      createdDate: '2024-02-06T10:08:20.430Z',
      modifiedDate: '2024-02-06T10:11:58.191Z',
      fingerprint:
        '0810e6c1b6fd92ce28da16744790d9924ebdf93e38cd070fecb759e8fba7f192',
    },
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.RETRY,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'RETRY',
  },
  {
    locationId: '30951341-6bdc-44e2-bf7d-2a4db709e4d8',
    locationName: 'ACH Loc5 status Verified and no funding account',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: null,
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.VERIFIED,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'FUNDING_SOURCE_REQUIRED',
  },
  {
    locationId: '30951341-6bdc-44e2-bf7d-2a4db709e4d9',
    locationName: 'ACH Loc6 overall status unenrolled',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: 'c9c8bca3-ac3b-42a7-a08b-a330dac335df',
    externalId: '32cdec23-4db8-4935-b0c4-4e2c806c52ae',
    firstName: 'Test Account',
    lastName: 'ACH',
    email: 'aetqatest22@gmail.com',
    phone: null,
    address1: '160 Apex Dr',
    address2: null,
    city: 'Boston',
    state: 'Massachusetts',
    postalCode: '12414',
    ipAddress: null,
    businessName: null,
    businessType: null,
    businessClassification: null,
    fundingAccount: null,
    type: ACHLocationBusiness.PERSONAL,
    status: ACHLocationStatus.UNVERIFIED,
    acceptedTOSAndPP: true,
    achLocationDocuments: null,
    createdDate: '2024-02-06T09:36:33.090Z',
    modifiedDate: '2024-02-06T09:36:33.366Z',
    controller: null,
    copiedFromLocationId: null,
    sharedCustomer: false,
    sharedFundingSource: false,
    fundTransferEnabled: false,
    overallStatus: 'UNENROLLED',
  },
];
